/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Rihard Tsybulka <rykhard.tsybulka@noogadev.com>
 */

import { createAction } from '../../../../utils/redux-utils';
import { Notification } from '../../../../utils/utils';
import { CashBoxErrorsHistoryQueryParams } from '../../../api/cashBoxes/cashBoxesClient.typings';

export enum CashBoxErrorHistoryTabActionType {
    EXIT_CASHBOX_ERRORS_HISTORY_TAB = 'CashBoxErrorsHistoryTab/ exit tab',
    FETCH_ERRORS_HISTORY = 'CashBoxErrorsHistoryTab/ fetch cashbox errors start',
    FETCH_ERRORS_HISTORY_SUCCESS = 'CashBoxErrorsHistoryTab/ fetch cashbox errors success',
    FETCH_ERRORS_HISTORY_ERROR = 'CashBoxErrorsHistoryTab/ fetch cashbox errors history error',
}

export const exitCashBoxErrorsHistoryTabAction = () =>
    createAction(CashBoxErrorHistoryTabActionType.EXIT_CASHBOX_ERRORS_HISTORY_TAB);

export const fetchCashBoxErrorsHistoryAction = (params: CashBoxErrorsHistoryQueryParams) =>
    createAction(CashBoxErrorHistoryTabActionType.FETCH_ERRORS_HISTORY, params);

export const fetchCashBoxErrorsHistorySuccessAction = (payload: any) =>
    createAction(CashBoxErrorHistoryTabActionType.FETCH_ERRORS_HISTORY_SUCCESS, payload);

export const fetchCashBoxErrorsHistoryErrorAction = (notification: Notification) =>
    createAction(CashBoxErrorHistoryTabActionType.FETCH_ERRORS_HISTORY_ERROR, { notification });

export type CashBoxErrorHistoryTabAction =
    | ReturnType<typeof exitCashBoxErrorsHistoryTabAction>
    | ReturnType<typeof fetchCashBoxErrorsHistoryAction>
    | ReturnType<typeof fetchCashBoxErrorsHistorySuccessAction>
    | ReturnType<typeof fetchCashBoxErrorsHistoryErrorAction>;
